module.exports = __webpack_public_path__ + "img/cement_taupe_ba_list.62a3414f.jpg";